import { WarningBanner } from 'ui/banner';
import { useSelector } from 'react-redux';

import { useTranslation } from '../../hooks/useTranslation';
import { selectShowValidations, selectValidationMessages } from '../selectors';
import { HANDLEBARS_FORBIDDEN_MESSAGE } from '../helpers';

type ValidationErrorProps = {
  title: string;
};

export const ValidationError = ({ title }: ValidationErrorProps) => {
  const { t } = useTranslation();
  const showValidations = useSelector(selectShowValidations);
  const validationErrors: string[] | undefined = useSelector(selectValidationMessages);
  const containsHandlebars = validationErrors?.includes(HANDLEBARS_FORBIDDEN_MESSAGE);
  const errorMessageKey = containsHandlebars ? 'forbiddenHandlebarsUsage' : 'general';

  if (!showValidations || !validationErrors?.length) {
    return null;
  }

  return (
    <WarningBanner title={title} data-test="query-builder--validation-error">
      <p>{t(`validationError.${errorMessageKey}`)}</p>
    </WarningBanner>
  );
};
